import React, {useEffect, useState} from "react";
import s from './CourseSectionHeader.module.scss';
import {ISectionModel} from "../../../../models/view/bootCampPage/IBootCampPageModel";
import {FontIcon} from "../../../common/FontIcon";
import {
  CourseLessonProgressMarker
} from "../../../courseOverview/courseLessonProgress/courseLessonProgressMarker/CourseLessonProgressMarker";
import {SectionAwardIcon} from "../../../lesson/sectionEndModal/sectionEndAwarded/sectionAwardIcon/SectionAwardIcon";

interface ISectionHeaderProps {
  sectionNumber: number,
  sectionModel: ISectionModel,
  showDetails: boolean
}

export default function CourseSectionHeader({sectionNumber, sectionModel, showDetails}: ISectionHeaderProps) {
  const progressBarLabel = getProgressBarLabel(sectionModel);
  const [svgMarkerPadWidthPercent, setSvgMarkerPadWidthPercent] = useState<number>(0);
  const [svgMarkerDisplayWidthPercent, setSvgMarkerDisplayWidthPercent] = useState<number>(0);
  const totalLessons = sectionModel.cards.length;
  const completedLessonCount = getCompletedLessonCount(sectionModel);

  useEffect(() => {
    const displayPercentForPadding: number = 5;
    const displayPercentForDisplay: number = (100 - displayPercentForPadding);
    setSvgMarkerPadWidthPercent(displayPercentForPadding / (totalLessons - 1));
    setSvgMarkerDisplayWidthPercent(displayPercentForDisplay / totalLessons);
  }, [totalLessons]);

  return (
    <summary className={`${s.courseSectionHeader} ${showDetails ? s.visible : s.hidden}`}>
      <div className={s.arrowContainer}>
        <FontIcon icon={"icon-angle-right"} />
      </div>
      <div className={s.sectionNumber}>{sectionNumber}</div>
      <div className={s.nameAndDescription}>
        <div className={s.name}>{sectionModel.name}</div>
        <div className={s.description}>{sectionModel.description}</div>
      </div>
      <div className={s.progressBarContainer}>
        {completedLessonCount >= 1 && completedLessonCount < totalLessons ?
          <div className={s.progressBar}>
            <svg className={s.progressChart} viewBox={"0 0 80 30"} width={"40px"} height={"25px"}>
              {sectionModel.cards.map((card, index) => {
                const {isComplete, difficultyCategory, number} = card;
                return <CourseLessonProgressMarker
                  key={`CourseLessonProgressMarker-${number}`}
                  lessonNumber={number}
                  isCompleted={isComplete}
                  difficultyCategory={difficultyCategory}
                  displayIndex={index}
                  paddingPercentWidth={svgMarkerPadWidthPercent}
                  displayPercentWidth={svgMarkerDisplayWidthPercent}
                />
              })}
            </svg>
          </div>
          : null
        }
        {completedLessonCount === totalLessons ?
          <SectionAwardIcon sectionNumber={0} courseId={sectionModel.courseId} />
          : <div className={s.progressBarLabel} title={'Lessons in the section'}>{progressBarLabel}</div>}
      </div>
    </summary>
  );
}

function getCompletedLessonCount(sectionModel: ISectionModel): number {
  let completedLessons = 0;
  sectionModel.cards.forEach((card) => { if (card.isComplete) { completedLessons++; }});

  return completedLessons;
}

function getProgressBarLabel(sectionModel: ISectionModel): string {
  const totalLessons = sectionModel.cards.length;

  let completedLessons = 0;
  sectionModel.cards.forEach((card) => { if (card.isComplete) { completedLessons++; }});

  let label = ``;
  if (completedLessons === 0 || completedLessons === totalLessons) {
    label = `${totalLessons}`;
  } else {
    label = `${completedLessons} / ${totalLessons}`;
  }

  return label;
}
